var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPavzaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 228.363,
    height: 33.267,
    viewBox: "0 0 228.363 33.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 228.363,
    height: 33.267,
    transform: "translate(0 0)",
    fill: "#0d47a1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.041,25.01v7.681H0V15.89H28.851a2.965,2.965,0,0,0,3.312-3.072c0-1.537-1.1-2.881-3.312-2.881H.048L7.393.576H27.218C37.443.576,43.3,5.665,43.3,12.865c0,7.249-5.857,12.145-16.13,12.145Z",
    fill: "#0d47a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.01,32.69l6.721-9.217h7.2c1.536,0,3.36,0,4.369.1a35.981,35.981,0,0,1-2.208-3.025l-5.377-7.824L51.362,32.69H38.208L58.754,4.08C60.29,1.92,62.45,0,65.907,0c3.36,0,5.52,1.776,7.1,4.08l19.97,28.61Z",
    fill: "#0d47a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.41,29.234a8.506,8.506,0,0,1-7.152,4.032A8.152,8.152,0,0,1,99.2,29.234L79.183.576H92.816l13.633,19.97L120.8.576h13.153Z",
    fill: "#0d47a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.44,32.69c-2.784,0-5.185-1.632-5.185-4.512a5.593,5.593,0,0,1,2.449-4.369l11.089-8.592c5.568-4.32,6.913-5.184,7.537-5.521-1.153.144-3.265.241-10.8.241H132.96L140.016.576h28.8C171.6.576,174,2.208,174,5.088a5.808,5.808,0,0,1-2.449,4.369L160.658,18a80.867,80.867,0,0,1-7.777,5.712c.576-.143,3.985-.24,11.329-.24h11.473l-6.721,9.217Z",
    fill: "#0d47a1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.392,32.69l6.721-9.217h7.2c1.536,0,3.36,0,4.368.1a36.2,36.2,0,0,1-2.208-3.025L201.1,12.721,186.745,32.69H173.591L194.137,4.08c1.536-2.16,3.7-4.08,7.152-4.08,3.361,0,5.521,1.776,7.1,4.08l19.97,28.61Z",
    fill: "#0d47a1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPavzaLogo);
export default __webpack_public_path__ + "static/media/PavzaLogo.94642717c5173c9a07aaa54072694739.svg";
export { ForwardRef as ReactComponent };